import Overview from '../pages/Initiative';
import Assistant from '../pages/Assistant';
import Account from '../pages/Account';
import { chatbubbleEllipses, cube } from 'ionicons/icons';
import { Initiative, NestedRoute } from './Types';

import generateClientRoutes from '../modules/client/Routes'
import Prompts from '../pages/Prompts';

const coreRoutes: NestedRoute[] = [
  { path: '/prompts', component: Prompts, exact: true, label: "prompts" },
  { path: '/account', component: Account, exact: true, label: "account" }
];

const generateAssistantRoutes = (data : any) => {

  if (data != null) {

      return data.map((assistant: { slug: string; name: string }) => ({
        path: `/${assistant.slug}`,
        component: Assistant,
        exact: true,
        label: assistant.name,
        icon: chatbubbleEllipses, 
        menu: true
      }));
    }
    else {

      return [];
    }
  };


const generateRoutes = (initiative : Initiative): NestedRoute[] => {

  if (!initiative || initiative == null)
    return [];

  if (initiative.initiative_type === "client") {
    
    return [...coreRoutes, ...generateClientRoutes(initiative.folders)];
  } 
  else {
    
    return [...coreRoutes];
  }  
}

export default generateRoutes;

